import axios from "../../axiosDod.js";
const getDodSettingsByType = async ({ commit }, data) => {
  const params = { limit: Number.MAX_SAFE_INTEGER };
  const { type } = data;
  if (type) {
    params.type = type;
  }
  const settings = await axios.get(`settings`, { params });
  commit("SET_DOD_SETTINGS", settings.data);
};

const updateSettingsByType = async (_, payload) => {
  const { type, data } = payload;
  await axios.put(`settings/types/${type}`, data);
};

const getDodDepartments = async ({ commit }) => {
  const params = { limit: Number.MAX_SAFE_INTEGER, type: "DEPARTMENT" };

  const settings = await axios.get(`settings`, { params });
  commit("SET_DOD_DEPARTMENTS", settings.data);
};

const getDodScopesOfCare = async ({ commit }) => {
  const params = { limit: Number.MAX_SAFE_INTEGER, type: "SCOPE_OF_CARE" };
  const settings = await axios.get(`settings`, { params });
  commit("SET_DOD_SCOPES_OF_CARE", settings.data);
};

const getDodPriorities = async ({ commit }) => {
  const response = await axios.get(`settings`, {
    params: { type: "PRIORITY_STATUS" },
  });
  commit("SET_DOD_PRIORITIES", response.data);
};

const generateAgreementPdf = async (_, data) => {
  try {
    const { employeeId, signingDate } = data;
    const response = await axios.post(
      `pdf/agreement`,
      { employeeId, signingDate },
      {
        responseType: "blob",
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const generateAgreementCompanyPdf = async (_, data) => {
  try {
    const { employeeId, signingDate } = data;
    const response = await axios.post(
      `pdf/agreementCompany`,
      { employeeId, signingDate },
      {
        responseType: "blob",
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const generateClientAgreementPdf = async (_, customerId) => {
  try {
    const response = await axios.post(
      `pdf/agreementClient`,
      { customerId },
      {
        responseType: "blob",
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const generateStatementPdf = async (_, employeeId) => {
  try {
    const response = await axios.post(
      `pdf/statement`,
      { employeeId },
      {
        responseType: "blob",
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const generateWorkingCardPdf = async (_, data) => {
  try {
    const { orderId, month, year } = data;
    const response = await axios.post(
      `pdf/workCard`,
      { orderId, month: month ? Number(month) : "", year },
      {
        responseType: "blob",
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const generateDodSqlReport = async ({ commit }, data) => {
  const response = await axios.get(`sqlReports/generate`, {
    params: { sql: data.sql },
  });
  commit("SET_SQL_REPORT", response.data);
};

const generateDodSqlReportXLSX = async (_, data) => {
  const response = await axios(`sqlReports/generateXLSX`, {
    method: "GET",
    headers: {
      "Content-Disposition": "attachment; filename=raport.xls",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "blob",
    params: { sql: data.sql },
  });
  return response;
};

const saveSqlReport = async ({ dispatch }, data) => {
  const response = await axios.post("sqlReports", data);
  if (response && response.data) {
    await dispatch("fetchSavedSqlReports");
    return true;
  } else {
    return false;
  }
};

const fetchSavedSqlReports = async ({ commit }) => {
  const response = await axios.get("sqlReports", {
    params: { limit: Number.MAX_SAFE_INTEGER },
  });
  if (response && response.data) {
    commit("SET_SQL_REPORTS", response.data.data);
  } else {
    return false;
  }
};

const deleteSqlReport = async ({ dispatch }, id) => {
  const response = await axios.delete(`sqlReports/${id}`);
  if (response && response.data) {
    await dispatch("fetchSavedSqlReports");
    return true;
  } else {
    return false;
  }
};

export default {
  getDodSettingsByType,
  getDodDepartments,
  getDodScopesOfCare,
  getDodPriorities,
  generateAgreementPdf,
  generateStatementPdf,
  updateSettingsByType,
  generateWorkingCardPdf,
  generateDodSqlReport,
  generateDodSqlReportXLSX,
  saveSqlReport,
  fetchSavedSqlReports,
  deleteSqlReport,
  generateClientAgreementPdf,
  generateAgreementCompanyPdf,
};
